// Backend-free demo bootstrap. Active ONLY in a VITE_DEMO=1 build (dist-demo);
// no ?demo=1 runtime escape so the real client can never serve synthetic data.

import { routeApi } from "./router";
import { DemoWebSocket } from "./websocket";
import { installControls } from "./controls";

export function isDemo(): boolean {
  try {
    return !!(import.meta.env && import.meta.env.VITE_DEMO === "1");
  } catch {
    return false;
  }
}

function installFetch(): void {
  const orig = window.fetch.bind(window);
  window.fetch = async (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
    const raw = typeof input === "string" ? input : input instanceof URL ? input.href : (input as Request).url;
    let path = raw;
    try { path = new URL(raw, window.location.origin).pathname + new URL(raw, window.location.origin).search; } catch { /* keep raw */ }
    if (!path.includes("/api/")) return orig(input, init);
    const method = (init?.method || (typeof input === "object" && "method" in input ? (input as Request).method : "GET")).toUpperCase();
    let body: unknown;
    try { body = init?.body ? JSON.parse(init.body as string) : undefined; } catch { /* non-json */ }
    try { return routeApi(path, method, body); } catch (err) { console.warn("[demo] route error", path, err); return new Response("{}", { status: 200, headers: { "Content-Type": "application/json" } }); }
  };
}

function installWebSocket(): void {
  // The realtime feed (/api/ws/realtime) is driven by the synthetic
  // DemoWebSocket so the dashboard animates with no backend.
  window.WebSocket = DemoWebSocket as unknown as typeof WebSocket;
}

export function installDemo(): void {
  // G2: MQTT defaults ON; force it off so the app uses the /api/ws/realtime
  // WebSocket path (which the demo shim drives) instead of EMQX + token.
  try {
    window.localStorage.setItem("mqtt_v2", "0");
  } catch {
    /* private mode / no storage — ignore */
  }
  installFetch();
  installWebSocket();
  installControls();
  // eslint-disable-next-line no-console
  console.log("%c[demo] dyno demo mode active", "color:#22c55e");
}
